import { useState } from "react";
import { Plus } from "lucide-react";
import { FadeUp } from "./Reveal";

const FAQS = [
    {
        q: "What does Bath & Beyond do?",
        a: "Bath & Beyond is a bathroom renovation company in Bangalore and a Spaces by Samita Venture. We renovate existing bathrooms — and build new bathrooms in homes under construction — into premium, spa-like spaces. Design, fittings, lighting, plumbing and electrical work are all handled by one team.",
    },
    {
        q: "How much does a bathroom renovation cost in Bangalore?",
        a: "Every bathroom is different, so we don't publish one-size-fits-all prices. After a short design visit we share a clear, fixed quote covering tiles, fittings, lighting, plumbing and electrical work — with no hidden extras.",
    },
    {
        q: "How long does a bathroom renovation take?",
        a: "A turnkey Bath & Beyond renovation is completed by one dedicated team in a matter of weeks, not months. Your exact timeline is confirmed in writing with your fixed quote before any work begins.",
    },
    {
        q: "Which areas of Bangalore do you serve?",
        a: "We renovate bathrooms across Bangalore, including Koramangala, Indiranagar, Whitefield, HSR Layout, Jayanagar, Sadashivanagar, Hebbal and nearby neighbourhoods.",
    },
    {
        q: "Who is behind Bath & Beyond?",
        a: "Bath & Beyond is a venture by Spaces by Samita, the interior design studio led by founder and interior designer Samita Menon. Every bathroom is designed under her eye, from the first sketch to the final handover.",
    },
];

const Faq = () => {
    const [open, setOpen] = useState(0);

    return (
        <section className="bg-[#EFE9DE] text-ink border-t hairline-light" data-testid="faq-section">
            <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-16 sm:py-24">
                <div className="max-w-2xl mb-10 sm:mb-14">
                    <FadeUp>
                        <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-sand mb-5">
                            Questions, answered
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.08}>
                        <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(1.9rem,3.6vw,3rem)]">
                            Bathroom renovation in Bangalore &mdash; the honest answers.
                        </h2>
                    </FadeUp>
                </div>

                <div className="max-w-3xl">
                    {FAQS.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <FadeUp key={f.q} delay={i * 0.04}>
                                <div
                                    className="border-t hairline-light"
                                    data-testid={`faq-item-${i + 1}`}
                                >
                                    <button
                                        data-testid={`faq-question-${i + 1}`}
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        aria-expanded={isOpen}
                                        className="w-full flex items-center justify-between gap-6 text-left py-5 sm:py-6 group"
                                    >
                                        <h3 className="font-serif text-lg sm:text-2xl group-hover:text-sand transition-colors duration-300">
                                            {f.q}
                                        </h3>
                                        <Plus
                                            className={`h-5 w-5 shrink-0 text-sand transition-transform duration-500 ${
                                                isOpen ? "rotate-45" : "rotate-0"
                                            }`}
                                            aria-hidden="true"
                                        />
                                    </button>
                                    <div
                                        data-testid={`faq-answer-${i + 1}`}
                                        className="grid transition-[grid-template-rows] duration-500 ease-out"
                                        style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                                    >
                                        <div className="overflow-hidden">
                                            <p className="pb-6 sm:pb-7 pr-8 text-sm sm:text-base font-light leading-relaxed text-ink/70 max-w-2xl">
                                                {f.a}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </FadeUp>
                        );
                    })}
                    <div className="border-t hairline-light" />
                </div>
            </div>
        </section>
    );
};

export default Faq;
